import gql from 'graphql-tag';
import { PERMISSION_FRAGMENT, ROLE_FRAGMENT } from './fragment';

export const GET_ROLES = gql`
  query GetRoles {
    getRoles {
      ...RoleInfo
      permissions {
        ...PermissionInfo
      }
    }
  }
  ${ROLE_FRAGMENT}
  ${PERMISSION_FRAGMENT}
`;
